import { render, staticRenderFns } from "./ProblemAssignment.vue?vue&type=template&id=6fe6bdf7"
import script from "./ProblemAssignment.vue?vue&type=script&lang=js"
export * from "./ProblemAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports